import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '~/tools/makeStyles';
import { Typography, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ThemedButton from '../components/ThemedButton';

const useStyles = makeStyles((_theme) => ({
  root: {
    textAlign: 'center',
  },
  notice: {
    fontSize: 18,
    textAlign: 'center',
    fontWeight: 400,
    color: '#333333',
    marginTop: 0,
    marginBottom: 24,
  },
  welcomeText: {
    fontSize: 16,
    fontWeight: 400,
    textAlign: 'center',
    color: '#7B7270',
    marginTop: 0,
    marginBottom: 24,
  },
  inputLabel: {
    backgroundColor: 'white',
    fontSize: 14,
    color: '#7B7270',
    fontWeight: 400,
    transform: 'translate(14px, 15px) scale(1)',
  },
  input: {
    height: 40,
  },
  signInBtnContainer: {
    margin: '24px 0px 0px 0px',
  },
}));

const KioskLogin = ({ label, welcomeText, onSubmit }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [uniqueId, changeUniqueId] = useState('');

  const inputLabel = t('kiosk.enterPlaceholder', { kiosk_id: label });
  const kioskLabel = `${inputLabel} (${t('required')})`;

  useEffect(() => {
    document.title = t('docTitle.kioskLogin');
    return () => {
      // Temp use a clean up function here before declare specific titles for each page
      document.title = 'WorkTango Pulse';
    };
  }, [t]);

  const handleInputChange = (e) => {
    changeUniqueId(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    changeUniqueId('');
    onSubmit(uniqueId);
  };

  return (
    <form className={classes.root}>
      <Typography variant="h1" className={classes.notice}>
        {t('kiosk.welcome', { kiosk_id: label })}
      </Typography>
      {welcomeText && (
        <Typography variant="h2" className={classes.welcomeText}>
          {welcomeText}
        </Typography>
      )}
      <TextField
        required
        id="unique-id"
        label={kioskLabel}
        value={uniqueId}
        onChange={handleInputChange}
        className={classes.input}
        fullWidth
        variant="outlined"
        autoFocus
      />
      <div className={classes.signInBtnContainer}>
        <ThemedButton
          aria-label={t('survey.kiosk.login.button')}
          color="primary"
          variant="contained"
          className={classes.submitButton}
          classes={{
            disabled: classes.disabledButton,
          }}
          fullWidth
          type="submit"
          onClick={handleSubmit}
          disabled={!uniqueId}
        >
          {t('survey.kiosk.login.button')}
        </ThemedButton>
      </div>
    </form>
  );
};

KioskLogin.propTypes = {
  label: PropTypes.string,
  welcomeText: PropTypes.string,
  onSubmit: PropTypes.func,
};

export default KioskLogin;
